import ApplicationController from './application_controller';

// CFS visit note form: when the smart-date-input lands on a day that already has a
// non-invalidated, non-deleted visit note for this patient + discipline, surface an
// inline override prompt (alert + "Save anyway" checkbox) in the form footer next to
// the Save button. This replaces the legacy after-failed-save inline override —
// therapists see the conflict before clicking Save.
//
// The server-side validator (VisitNote#one_note_per_discipline_per_day) is still the
// source of truth on submit; this is purely a UX prompt.
//
// Mounted on the <form> element.
//
// Values:
//   data-vn-date-conflict-control-id-value: smart-date-input control id
//   data-vn-date-conflict-dates-value:      JSON array of conflict day strings ("YYYY-MM-DD")
//
// Target:
//   alert - the wrapper around the alert + checkbox; toggled via `hidden` attribute
export default class extends ApplicationController {
  static targets = ['alert'];
  static values = {
    controlId: String,
    dates: Array,
  };

  connect() {
    if (!this.controlIdValue) return;
    this.dosInput = this.element.querySelector(`[name*="[datum][${this.controlIdValue}][date]"]`);
    if (!this.dosInput) return;
    this.onChange = this.onChange.bind(this);
    this.dosInput.addEventListener('change', this.onChange);
    // Run once on mount so an already-conflicting initial value surfaces the prompt
    // without requiring a re-edit.
    this.onChange();
  }

  disconnect() {
    this.dosInput?.removeEventListener('change', this.onChange);
  }

  onChange() {
    const { value } = this.dosInput;
    // datetime-local format "YYYY-MM-DDTHH:MM" — the leading 10 chars are the day in the
    // user's local interpretation, which matches the conflict-dates list computed
    // server-side in current_user's timezone.
    const day = value ? value.slice(0, 10) : '';
    const conflicts = this.datesValue || [];
    if (day && conflicts.includes(day)) {
      this.#show();
    } else {
      this.#hide();
    }
  }

  #show() {
    if (this.hasAlertTarget) this.alertTarget.hidden = false;
  }

  #hide() {
    if (this.hasAlertTarget) this.alertTarget.hidden = true;
    // Reset the override checkbox when the conflict clears so the user can't accidentally
    // bypass a future validation that hasn't been acknowledged in this state.
    const cb = this.alertTarget?.querySelector('input[type="checkbox"][name*="override_validation"]');
    if (cb) cb.checked = false;
  }
}
